{
  "menu": {
    "about": "Über Uns",
    "facilities": "Ausstattung",
    "villas": "Villen & Preise",
    "allRooms": "Alle Zimmer",
    "experiences": "Aktivitäten",
    "gallery": "Galerie",
    "news": "Nachrichten",
    "contact": "Kontakt",
    "dining": "Essen",
    "spa": "Spa"
  },
  "cta": {
    "book": "Jetzt Buchen",
    "contact": "Kontaktiere Uns",
    "back_to_home": "Zurück zur Startseite",
    "read_more": "Weiterlesen"
  },
  "home": {
    "culture": {
      "subtitle": "Authentisches Balinesisches Erbe",
      "title": "Kulturelle Erlebnisse",
      "desc": "Tauchen Sie ein in das reiche spirituelle und kulturelle Erbe Balis. Von heiligen Wasserreinigungsritualen bis zur Erkundung alter Traditionen führen wir Sie auf eine Reise, um die wahre Seele der Insel zu entdecken.",
      "journeySub": "Spirituelle Reise",
      "journeyTitle": "Sidemen Reinigung",
      "journeyDesc": "Erleben Sie ein traditionelles balinesisches Wasserreinigungsritual (Melukat) in den heiligen Quellen von Sidemen, das entwickelt wurde, um Körper, Geist und Seele zu reinigen.",
      "btnReserve": "Reservierung"
    },
    "activities": {
      "subtitle": "Ausgewählte Momente",
      "title": "Unternehmungen",
      "desc": "Wir bieten die besten kuratierten Aktivitäten, um unvergessliche Erinnerungen während Ihres Aufenthalts zu schaffen. Tauchen Sie ein in die Magie Balis, von aufregenden Abenteuern bis hin zu tiefen kulturellen Erkundungen und spirituellem Wohlbefinden.",
      "btnView": "Aktivitäten ansehen",
      "btnReserve": "Reservierung"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Was uns unterscheidet",
      "desc": "Entdecken Sie die wahre Essenz eines versteckten Juwels. Fernab der Massen bieten wir ein abgelegenes Refugium, in dem jedes Detail darauf ausgelegt ist, Ihnen zu helfen, abzuschalten, neue Energie zu tanken und mit wunderschönen Erinnerungen zu gehen, die ein Leben lang halten.",
      "card1": {
        "sub": "Ein privates Refugium fernab der Welt",
        "title": "Sidemens verstecktes Juwel",
        "desc": "Abseits der belebten Straßen bietet unsere Villa ultimative Exklusivität und Privatsphäre. Hier sind Sie nicht nur ein Gast, sondern ein privilegierter Reisender, der die unberührte Gelassenheit des authentischen Bali erlebt."
      },
      "card2": {
        "sub": "Erwecken Sie Ihre Sinne und laden Sie Ihre Seele auf",
        "title": "Erneuerte Energie",
        "desc": "Atmen Sie die frische Luft unserer üppigen tropischen Gärten und weiten Reisfelder ein. Jeder Moment in unserer friedlichen Umgebung ist darauf ausgerichtet, Ihren Geist, Körper und Ihre Seele zu verjüngen."
      },
      "card3": {
        "sub": "Momente, die Sie für immer schätzen werden",
        "title": "Wunderschöne Erinnerungen",
        "desc": "Von herzlichen Lächeln bis hin zu authentischen lokalen Erlebnissen gestalten wir jedes Detail Ihres Aufenthalts mit aufrichtiger Sorgfalt. Kehren Sie nicht nur ausgeruht nach Hause zurück, sondern mit wunderschönen, unvergesslichen Geschichten, die Sie erzählen können."
      }
    },
    "booking": {
      "title": "Bereit, Patal Kikian zu erleben?",
      "desc": "Prüfen Sie die Verfügbarkeit und sichern Sie sich noch heute Ihr privates Refugium."
    },
    "contact": {
      "subtitle": "Kontakt",
      "title": "Wie Sie uns erreichen",
      "desc": "Ob Sie eine Frage zu unseren Zimmern haben, Hilfe bei Ihrer Buchung benötigen oder eine spezielle Anfrage für Ihren bevorstehenden Aufenthalt haben, unser engagiertes Concierge-Team ist für Sie da.",
      "btnEmail": "Eine E-Mail senden",
      "btnWa": "WhatsApp uns"
    },
    "hero": {
      "subtitle": "Willkommen in den Patal Kikian Villas",
      "title": "Erwachen Sie zu Balis atemberaubendstem Panorama",
      "description": "Umarmen Sie die majestätische Präsenz des Mount Agung, der über smaragdgrüne Reisterrassen und üppige, sanfte Täler wacht. Hier, in der friedlichen Umarmung von Sidemen, verweben sich die klare Bergluft und die unberührte Stille zu einem unvergesslichen Zufluchtsort für Ihre Seele."
    },
    "intro": {
      "quote": "\"Seit Jahrzehnten inspiriert die fesselnde Schönheit von Sidemen die Welt.\"",
      "p1": "Im Jahr 1938 verewigte der legendäre Künstler Walter Spies den bezaubernden Charme dieser Region durch sein Meisterwerk, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> Das Gemälde hielt die überragende Majestät des Mount Agung, die üppigen smaragdgrünen Reisterrassen, den sanften Morgennebel und den friedlichen Rhythmus des ländlichen balinesischen Lebens wunderbar fest. Bis heute bleibt es ein ikonisches Symbol für Balis natürliche Pracht.",
      "p2": "Heute entfaltet sich genau dieses atemberaubende Panorama direkt vor Ihren Augen in den Patal Kikian Villas.",
      "p3": "Jeder Morgen bringt einen spektakulären Sonnenaufgang, der den Mount Agung in goldenes Licht taucht, weite grüne Täler erleuchtet und eine frische Bergbrise mit sich bringt. Hier herrscht Ruhe und lässt die Zeit scheinbar langsamer vergehen.",
      "p4": "Im Patal Kikian wohnen Sie nicht nur in einer Luxusvilla; Sie tauchen ein in genau die Landschaft, die Künstler, Fotografen und Naturliebhaber aus aller Welt in ihren Bann gezogen hat.",
      "p5": "Wir bieten eine makellose Harmonie aus raffiniertem Luxus, tiefem kulturellem Erbe und der authentischen natürlichen Schönheit von Sidemen.",
      "footerQuote": "Kommen Sie für einen Urlaub. Gehen Sie mit Erinnerungen, nach denen Sie sich ewig sehnen werden.",
      "footerBrand": "Patal Kikian Villas",
      "footerTagline": "Wo jeder Sonnenaufgang zu einem Meisterwerk wird"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Restaurant",
      "desc": "Neben unserem Infinity-Pool und der eleganten Bar gelegen, bietet unser Restaurant ein bemerkenswertes kulinarisches Erlebnis, eingerahmt von einem weiten Blick auf die grünen Täler und weiten Reisfelder. Genießen Sie exquisite kulinarische Kreationen, während die sanfte Brise und die atemberaubende natürliche Umgebung Ihre Sinne wecken.",
      "callToAction": "Entdecken Sie unsere exquisiten kulinarischen Angebote. Entdecken Sie unsere lokalen und internationalen Spezialitäten, indem Sie unsere Speisekarte einsehen, oder reservieren Sie Ihren Tisch für ein unvergessliches kulinarisches Erlebnis.",
      "btnMenu": "Menü ansehen",
      "btnReserve": "Reservierung",
      "btnTransport": "Reservierung Spezialtransport",
      "btnTransportSub": "(Region Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Standort"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Spa",
      "desc": "Verjüngen Sie Geist, Körper und Seele im Patal Kikian Spa. Erleben Sie authentische balinesische Heilungsrituale und entspannende Massagen, die von unseren qualifizierten Therapeuten durchgeführt werden, während Sie die atemberaubende natürliche Schönheit von Sidemen genießen.",
      "callToAction": "Entdecken Sie unser gesamtes Angebot an ganzheitlichen Behandlungen. Sehen Sie sich unser Spa-Menü an, um unsere entspannenden Therapien zu erkunden, oder buchen Sie noch heute Ihre Verjüngungssitzung.",
      "btnMenu": "Menü ansehen",
      "btnReserve": "Reservierung",
      "btnTransport": "Reservierung Spezialtransport",
      "btnTransportSub": "(Region Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Standort"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Patal Kikian Villen",
      "desc": "Jede Villa ist sorgfältig als Ihr privates Refugium gestaltet und bietet einen atemberaubenden, ungestörten Blick auf den Mount Agung, weite Reisfelder und üppig grüne Täler, wobei sich Luxus nahtlos mit der Gelassenheit der Natur verbindet."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Unsere Geschichte",
      "title": "Erwachen Sie zu Balis atemberaubendstem Panorama",
      "desc": "Umarmen Sie die majestätische Präsenz des Mount Agung, der über smaragdgrüne Reisterrassen und üppige Täler wacht. Hier in der friedlichen Umarmung von Sidemen verweben sich klare Bergluft und unberührte Gelassenheit zu einem unvergesslichen Zufluchtsort für Ihre Seele.",
      "btnScroll": "Geschichte Lesen"
    },
    "story": {
      "p1": "Die Patal Kikian Villas am Rande von Sidemen, Karangasem, sind mehr als nur ein Reiseziel. Es ist eine Einladung, den wahren Herzschlag Balis zu erleben. Mit einem Panoramablick von der Spitze des Hügels beginnt hier jeder Morgen mit einer Sinfonie der Natur – einem goldenen Sonnenaufgang, der den majestätischen Gipfel des Mount Agung erleuchtet, eingerahmt von endlosem Grün und unberührten Landschaften.",
      "p2": "Wir glauben, dass wahrer Luxus in der Harmonie mit der Natur liegt. Wenn Sie unser Refugium betreten, werden Sie von frischer, klarer Bergluft und einem tiefen Gefühl der Ruhe umhüllt. Es ist ein Ort, der entworfen wurde, um Sie vom Lärm der Welt zu trennen und Sie wieder mit dem zu verbinden, was wirklich zählt.",
      "subtitle": "Eine Harmonie aus Natur und Kultur",
      "p3": "Unsere Villen spiegeln eine nahtlose Mischung aus traditioneller balinesischer Architektur und modernem Komfort wider, die sorgfältig gefertigt wurde, um die reiche Kultur von Sidemen zu ehren. Wir sind stolz auf unsere herzliche, authentische Gastfreundschaft. Hier ist jedes Lächeln echt, und jeder Service wird mit größtem Respekt für unsere Gäste und unser lokales Erbe erbracht.",
      "quote": "\"Die Patal Kikian Villas sind Ihr verstecktes Paradies – ein Ort, an dem majestätische Landschaften, reiche Kultur und herzliche Gastfreundschaft einen unvergesslichen Teppich aus Erinnerungen weben.\"",
      "footer": "Wir freuen uns darauf, Sie in unserem Refugium begrüßen zu dürfen."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Resort-Annehmlichkeiten",
      "title": "Unsere Einrichtungen",
      "desc": "Entdecken Sie unsere Premium-Annehmlichkeiten, die so konzipiert sind, dass sie Ihnen während Ihres gesamten Aufenthalts in Sidemen Komfort und Entspannung bieten.",
      "btnScroll": "Einrichtungen ansehen"
    },
    "fallback": {
      "poolSub": "Oase der Ruhe",
      "poolTitle": "Schwimmbäder",
      "poolDesc1": "Tauchen Sie ein in unsere kristallklaren Infinity-Pools mit Blick auf die tropischen Gärten und das üppige Tal. Egal, ob Sie ein morgendliches Bad, ein schwimmendes Frühstück genießen oder einfach nur bei einem erfrischenden Cocktail in der Sonne faulenzen, unsere Pools bieten den ultimativen Raum zur Entspannung.",
      "poolDesc2": "Für diejenigen, die einen intimen Rückzugsort suchen, stehen in ausgewählten Villen auch private Tauchbecken zur Verfügung.",
      "restSub": "Kulinarische Exzellenz",
      "restTitle": "Restaurant",
      "restDesc1": "Gönnen Sie sich eine gastronomische Reise in unserem charakteristischen Open-Air-Restaurant. Wir sind stolz darauf, authentische balinesische Küche neben internationalen Favoriten zu servieren, die alle aus frischen, lokal bezogenen Bio-Zutaten hergestellt werden.",
      "restDesc2": "Genießen Sie Ihr kostenloses Frühstück, romantische Abendessen bei Kerzenschein oder einen ungezwungenen Nachmittagstee und genießen Sie dabei die atemberaubende Aussicht auf die umliegende Natur.",
      "restBtn": "Mehr Anzeigen",
      "spaSub": "Wellness & Heilung",
      "spaTitle": "Luxus-Spa",
      "spaDesc1": "Verjüngen Sie Ihren Geist, Körper und Ihre Seele in unserem ruhigen Spa-Heiligtum. Verwurzelt in alten balinesischen Heiltraditionen bieten unsere professionellen Therapeuten eine Reihe von Behandlungen an, von traditionellen Massagen bis hin zu revitalisierenden Körperpeelings und Gesichtsbehandlungen.",
      "spaDesc2": "Als unser Gast erhalten Sie bei Ihrer Ankunft außerdem eine kostenlose 15-minütige Fußmassage, um Ihre Reisemüdigkeit sofort wegzuwaschen.",
      "spaBtn": "Mehr Anzeigen"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Unsere Zimmer",
      "title": "Heiligtümer der Gelassenheit in den Patal Kikian Villas",
      "desc": "Erleben Sie ultimative Ruhe in unseren sorgfältig gestalteten Villen, die modernen Komfort mit balinesischer Authentizität verbinden.",
      "btnScroll": "Zimmer Erkunden"
    },
    "detail": {
      "loading": "Zimmerdetails werden geladen...",
      "signature": "Signature-Zimmer",
      "gallerySub": "Galerie",
      "galleryTitle": "Zimmer-Fotogalerie",
      "noImages": "Für diesen Zimmertyp sind keine Bilder verfügbar.",
      "aboutRoom": "Über das Zimmer",
      "roomSize": "Zimmergröße",
      "bedSize": "Bettgröße",
      "view": "Aussicht",
      "amenities": "Ausstattung",
      "inclusions": "Inklusivleistungen",
      "pleaseNote": "Bitte beachten Sie",
      "roomRules": "Hausregeln & Informationen",
      "roomPolicy": "Zimmerrichtlinien",
      "childrenPolicies": "Richtlinien für Kinder",
      "childrenPolicyDesc": "Kinder jeden Alters sind willkommen. Kinder bis einschließlich 5 Jahre übernachten kostenlos. Für Kinder von 6 bis 12 Jahren berechnen wir 151.250,00 IDR pro Kind und Nacht im Zustellbett.",
      "babyCot": "Babybett",
      "babyCotDesc": "Kinder bis einschließlich 2 Jahre übernachten kostenlos in einem verfügbaren Babybett.",
      "extraBed": "Zustellbett",
      "extraBedDesc": "Personen jeden Alters übernachten für 302.500,00 IDR pro Person und Nacht in einem verfügbaren Zustellbett.",
      "noSmoking": "Rauchen ist nicht gestattet.",
      "noPets": "Haustiere sind nicht erlaubt.",
      "reserve": "Reservieren",
      "directBooking": "Direktbuchung bei uns",
      "bookOnBooking": "Auf Booking.com buchen",
      "contactConcierge": "Kontaktieren Sie unseren Concierge für Buchungsfragen und individuelle Wünsche.",
      "otherChoices": "Andere Auswahlmöglichkeiten",
      "otherRooms": "Andere Zimmer, die Ihnen gefallen könnten",
      "bookYourStay": "Buchen Sie Ihren Aufenthalt"
    }
  },
  "luxuryCard": {
    "discover": "Entdecken"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Deluxe Bungalow (Bergblick)",
      "description": "Dieser Bungalow verfügt über einen Infinity-Pool. Dieser klimatisierte Bungalow mit eigenem Eingang besteht aus 1 Wohnzimmer, 1 separaten Schlafzimmer und 1 Badezimmer mit Dusche und Haartrockner. Der Bungalow ist mit einem Schreibtisch und einer Sitzecke ausgestattet und bietet eine Minibar, eine Tee- und Kaffeemaschine sowie Gartenblick. Die Einheit bietet 1 Bett.",
      "view": "Garten-, Pool-, Berg-, Wahrzeichen- & Flussblick",
      "roomRules": "Rauchen: Rauchen verboten. Ruhezeiten nach 22 Uhr. Check-in um 14 Uhr, Check-out um 12 Uhr."
    },
    "suite-room-mountain-view": {
      "title": "Suite Zimmer (Bergblick)",
      "description": "Gäste werden ein besonderes Erlebnis haben, da diese Suite einen Pool mit Aussicht bietet. Diese geräumige Suite verfügt über einen eigenen Eingang, 1 Schlafzimmer, einen Sitzbereich und 1 Badezimmer mit einer Dusche und einem Haartrockner. Die klimatisierte Unterkunft bietet Gartenblick, eine Terrasse und Wein/Champagner für die Gäste. Die Einheit bietet 1 Bett.",
      "view": "Berg-, Fluss-, Wahrzeichen-, Pool- & Gartenblick",
      "roomRules": "Rauchen: Rauchen verboten. Ruhezeiten nach 22 Uhr. Check-in um 14 Uhr, Check-out um 12 Uhr."
    },
    "private-pool-villa-mountain-view": {
      "title": "Private Pool Villa (Bergblick)",
      "description": "Diese Villa verfügt über einen Pool mit Aussicht. Diese klimatisierte Villa mit eigenem Eingang besteht aus 1 Wohnzimmer, 1 separaten Schlafzimmer und 1 Badezimmer mit Badewanne und Dusche. Die geräumige Villa bietet eine Minibar, eine Tee- und Kaffeemaschine, eine Sitzecke sowie eine Terrasse mit Gartenblick. Die Einheit bietet 1 Bett.",
      "view": "Garten-, Pool-, Berg- & Flussblick",
      "roomRules": "Rauchen: Rauchen verboten. Ruhezeiten nach 22 Uhr. Check-in um 14 Uhr, Check-out um 12 Uhr."
    },
    "features": {
      "Infinity Pool": "Infinity-Pool",
      "Mountain View": "Bergblick",
      "Private Balcony": "Privater Balkon",
      "Private Pool": "Privater Pool",
      "Mount Agung View": "Blick auf den Mount Agung",
      "Living Room": "Wohnzimmer",
      "Nature View": "Naturblick",
      "Bedroom": "Schlafzimmer"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Dinge zu tun",
      "title": "Schaffen Sie Ihre besten Erinnerungen auf Bali",
      "desc": "Von atemberaubenden Naturabenteuern bis hin zu immersiven kulturellen Erlebnissen präsentieren wir eine kuratierte Auswahl an Aktivitäten, um jeden Moment Ihres Urlaubs noch spezieller zu machen.",
      "btnScroll": "Aktivitäten Ansehen"
    },
    "sidebar": {
      "categories": "Kategorien",
      "moreActivities": "Mehr Aktivitäten"
    },
    "categories": {
      "Adventure & Nature": "Abenteuer & Natur",
      "Culture & Art": "Kultur & Kunst",
      "Wellness & Spiritual": "Wellness & Spiritualität"
    },
    "items": {
      "ATV Adventure": {
        "title": "ATV Abenteuer",
        "description": "Erleben Sie den Nervenkitzel einer ATV-Fahrt durch die wunderschönen Landschaften Balis."
      },
      "Cycling Tour": {
        "title": "Radtour",
        "description": "Radeln Sie auf einer geführten Tour durch üppige Reisfelder und traditionelle Dörfer."
      },
      "Rice Terrace Walking Tour": {
        "title": "Reisterrassen-Wanderung",
        "description": "Machen Sie einen friedlichen Spaziergang durch einige der berühmtesten Reisterrassen der Welt."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Sonnenaufgangs-Jeep am Mount Batur",
        "description": "Erleben Sie einen atemberaubenden Sonnenaufgang vom Mount Batur ohne die frühmorgendliche Wanderung."
      },
      "Scooter Tour": {
        "title": "Roller-Tour",
        "description": "Erkunden Sie die verborgenen Schätze von Sidemen auf einer aufregenden geführten Roller-Tour."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Erleben Sie den Adrenalinschub beim Wildwasser-Rafting auf dem Ayung."
      },
      "Batur Trekking": {
        "title": "Batur Trekking",
        "description": "Wandern Sie auf den aktiven Vulkan Mount Batur und beobachten Sie den Sonnenaufgang vom Gipfel aus."
      },
      "Waterfall Tour": {
        "title": "Wasserfall-Tour",
        "description": "Besuchen Sie einige der atemberaubendsten und verstecktesten Wasserfälle in der Region Sidemen."
      },
      "Swing": {
        "title": "Schaukeln",
        "description": "Erleben Sie das Adrenalin beim Schaukeln hoch über den atemberaubenden Tälern und Dschungeln Balis."
      },
      "Mount Agung Trekking": {
        "title": "Mount Agung Trekking",
        "description": "Fordern Sie sich mit einer lohnenden Sonnenaufgangswanderung zum höchsten Gipfel Balis, dem Mount Agung, heraus."
      },
      "Cooking Class": {
        "title": "Kochkurs",
        "description": "Lernen Sie die Geheimnisse der authentischen balinesischen Küche mit unseren erfahrenen lokalen Köchen."
      },
      "Silver Class": {
        "title": "Silber-Kurs",
        "description": "Kreieren Sie Ihren eigenen einzigartigen Silberschmuck, angeleitet von traditionellen Silberschmieden."
      },
      "Coffee Plantation Tour": {
        "title": "Kaffeeplantagen-Tour",
        "description": "Entdecken Sie den Herstellungsprozess von traditionellem balinesischen Kaffee, einschließlich des berühmten Luwak-Kaffees."
      },
      "Yoga & Wellness": {
        "title": "Yoga & Wellness",
        "description": "Verjüngen Sie Ihren Geist und Körper mit unseren geführten Yoga- und Wellness-Sitzungen."
      }
    }
  },
  "restaurant": {
    "items": {
      "Vegetable Spring Roll": {
        "name": "Gemüse-Frühlingsrolle",
        "description": "Frittierte Gemüse-Frühlingsrolle, serviert mit süßer Chilisauce"
      },
      "Bruschetta": {
        "name": "Bruschetta",
        "description": "Knuspriges Baguette, Tomatensalsa, Zwiebeln, Basilikum und Parmesankäse"
      },
      "Garlic Cheese Bread": {
        "name": "Knoblauch-Käse-Brot",
        "description": "Knuspriges Baguette mit Mozzarella-Käse"
      },
      "Onion Soup": {
        "name": "Zwiebelsuppe",
        "description": "Karamellisierte Zwiebelsuppe serviert mit Knoblauch-Käse-Brot"
      }
    },
    "categories": {
      "Appetizers": "Vorspeisen",
      "Soup": "Suppen",
      "Pasta": "Pasta",
      "Main Course": "Hauptgerichte",
      "Indonesian Food": "Indonesische Küche",
      "Dessert": "Desserts",
      "Beverages": "Getränke"
    },
    "hero": {
      "subtitle": "Blätterwald Restaurant",
      "title": "Eine kulinarische Reise für die Seele",
      "desc": "Gönnen Sie sich exquisite kulinarische Kreationen, die den Körper nähren, begleitet vom majestätischen Panorama des Mount Agung...",
      "btnScroll": "Menü ansehen"
    },
    "sidebar": {
      "categories": "Kategorien",
      "moreCategories": "Mehr Kategorien"
    },
    "backToHome": "Zurück zur Startseite"
  },
  "spa": {
    "items": {
      "Balinese Massage": {
        "name": "Balinesische Massage",
        "description": "Authentische traditionelle Massage kombiniert mit balinesischer Technik, Dehnung und Drucktechniken."
      },
      "Frequent Flyer Massage": {
        "name": "Vielflieger-Massage",
        "description": "Das perfekte Heilmittel nach einem langen Flug, um Verspannungen zu lösen."
      },
      "Therapeutic Sport Massage": {
        "name": "Therapeutische Sportmassage",
        "description": "Ideal zur Durchblutungsförderung, Heilung von Verletzungen und tiefen Entspannung."
      },
      "Durma Healthy Massage": {
        "name": "Durma Gesundheitsmassage",
        "description": "Ultimatives Massageerlebnis, beginnend mit einem balinesischen Fußbad."
      },
      "Aromatherapy Massage": {
        "name": "Aromatherapie-Massage",
        "description": "Entspannende Massage mit ätherischen Ölen aus Kräutern und Pflanzen."
      },
      "Patal kikian Stone Massage": {
        "name": "Patal Kikian Steinmassage",
        "description": "Naturheilkunde mit warmen Flusssteinen zur Muskelentspannung."
      },
      "Massage Reflexology": {
        "name": "Reflexzonenmassage",
        "description": "Alte chinesische Heilkunst, die sich auf die Druckpunkte der Füße konzentriert."
      },
      "Flower Bath": {
        "name": "Blumenbad",
        "description": "Heilpraktik zur Beseitigung emotionaler Hindernisse und Verbesserung Ihrer Aura."
      },
      "Nail Gel Polish": {
        "name": "Gel-Nagellack",
        "description": "Mit UV-Lampe gehärteter Nagellack für eine glänzende, lang anhaltende Maniküre."
      },
      "Foot Massage": {
        "name": "Fußmassage",
        "description": "Massage, die sich auf die Muskeln der Füße konzentriert, um Verspannungen zu lösen."
      },
      "Boreh Scrub & Mask": {
        "name": "Boreh Peeling & Maske",
        "description": "Traditionelle Kräutermischung, die die Haut sanft poliert, nährt und revitalisiert."
      },
      "Chocolate Scrub & Mask": {
        "name": "Schokoladen-Peeling & Maske",
        "description": "Feuchtigkeitsspendendes Peeling mit Kakaoextrakten."
      },
      "Coconut Scrub & Mask": {
        "name": "Kokosnuss-Peeling & Maske",
        "description": "Kokosnuss-Behandlung für tiefe Feuchtigkeit."
      },
      "Refresh Facial": {
        "name": "Erfrischende Gesichtsbehandlung",
        "description": "Schnelle Behandlung zur Reinigung und Feuchtigkeitsversorgung der Haut."
      },
      "Traditional Facial": {
        "name": "Traditionelle Gesichtsbehandlung",
        "description": "Komplette Gesichtsbehandlung mit traditionellen balinesischen Inhaltsstoffen."
      },
      "Spa Manicure": {
        "name": "Spa-Maniküre",
        "description": "Komplette Handpflege mit Nagelformung und Feuchtigkeitsversorgung."
      },
      "Spa Pedicure": {
        "name": "Spa-Pediküre",
        "description": "Entspannende Fußpflege mit Peeling, Massage und Nagelpflege."
      },
      "Queen of Kikian": {
        "name": "Königin von Kikian",
        "description": "Das Nonplusultra der Spa-Pflege mit Balinesischer Massage, Peeling, Gesichtspflege und Blumenbad."
      },
      "Breeze of Sidemen": {
        "name": "Brise von Sidemen",
        "description": "Tiefe Entspannung mit Aromatherapie-Massage und entspannendem Bad."
      },
      "A Taste of Heaven": {
        "name": "Ein Hauch von Himmel",
        "description": "Göttliche Behandlung mit therapeutischer Massage und Reflexzonenmassage."
      },
      "bookTreatment": "Behandlung Buchen"
    },
    "categories": {
      "Body Massage": "Körpermassage",
      "Specialty Treatments": "Spezialbehandlungen",
      "Body Scrub and Mask": "Körperpeeling und Maske",
      "Facial Treatment": "Gesichtsbehandlung",
      "Manicure and Pedicure": "Maniküre und Pediküre",
      "Spa Packages": "Spa-Pakete"
    },
    "hero": {
      "subtitle": "Willkommen im Patal Kikian Spa",
      "title": "Wo der Körper ruht, kehrt die Seele zurück",
      "desc": "Unser Spa kümmert sich um Ihren müden Körper, während die üppige Natur von Sidemen Ihr müdes Herz umarmt...",
      "btnScroll": "Spa-Menü ansehen"
    },
    "sidebar": {
      "treatments": "Behandlungen",
      "moreTreatments": "Mehr Behandlungen"
    },
    "backToHome": "Zurück zur Startseite"
  },
  "contact": {
    "hero": {
      "subtitle": "Kontaktiere uns",
      "title": "Kontakt",
      "desc": "Wir sind hier, um Ihnen zu helfen. Kontaktieren Sie uns für Anfragen, Reservierungen oder spezielle Wünsche.",
      "scroll": "Kontaktiere uns"
    },
    "info": {
      "title": "Information",
      "desc": "Haben Sie eine Frage oder benötigen Sie Hilfe? Unser Team ist immer bereit, Ihnen zu helfen, Ihren perfekten Aufenthalt in Sidemen zu planen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Senden Sie uns eine Nachricht",
      "name": "Dein Name",
      "email": "Deine E-Mail",
      "subject": "Betreff",
      "message": "Nachricht",
      "btnSend": "Nachricht Senden",
      "btnSending": "Senden...",
      "success": "Danke! Ihre Nachricht wurde erfolgreich gesendet.",
      "error": "Hoppla! Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal."
    }
  },
  "faq": {
    "q1": {
      "question": "Wann sind die Check-in- und Check-out-Zeiten?",
      "answer": "Die Check-in-Zeit ist um 14:00 Uhr und der Check-out ist um 12:00 Uhr (Mittag). Ein früher Check-in oder später Check-out unterliegt der Verfügbarkeit und kann mit zusätzlichen Kosten verbunden sein."
    },
    "q2": {
      "question": "Ist das Frühstück im Zimmerpreis inbegriffen?",
      "answer": "Ja, ein kostenloses tägliches Frühstück ist bei allen unseren Villenbuchungen inbegriffen."
    },
    "q3": {
      "question": "Bieten Sie Flughafentransfers an?",
      "answer": "Ja, wir bieten Flughafentransfers gegen Aufpreis an. Bitte kontaktieren Sie uns im Voraus, um Ihre Abholung zu arrangieren."
    },
    "q4": {
      "question": "Ist Patal Kikian familienfreundlich?",
      "answer": "Obwohl wir Gäste jeden Alters willkommen heißen, ist unser Anwesen als ruhiger Rückzugsort konzipiert. Eltern müssen ihre Kinder jederzeit beaufsichtigen, insbesondere in der Nähe des Poolbereichs."
    },
    "q5": {
      "question": "Berücksichtigen Sie diätetische Einschränkungen?",
      "answer": "Absolut. Unser Restaurant kann auf verschiedene Ernährungsbedürfnisse eingehen, einschließlich vegetarischer, veganer und glutenfreier Optionen. Bitte informieren Sie uns vor Ihrer Ankunft über Ihre Bedürfnisse."
    },
    "q6": {
      "question": "Ist WLAN in der Villa verfügbar?",
      "answer": "Ja, kostenloses Highspeed-WLAN ist im gesamten Anwesen verfügbar, einschließlich aller Zimmer und öffentlichen Bereiche."
    },
    "subtitle": "Information",
    "title": "Häufig gestellte Fragen",
    "stillHaveQuestions": "Haben Sie noch Fragen?",
    "btnContact": "Kontaktiere uns"
  },
  "terms": {
    "usage": {
      "title": "Website-Nutzung",
      "p1": "Willkommen auf unserer Website. Wenn Sie diese Website weiterhin nutzen, stimmen Sie den folgenden Nutzungsbedingungen zu, die zusammen mit unserer Datenschutzrichtlinie die Beziehung von Patal Kikian Villas zu Ihnen in Bezug auf diese Website regeln.",
      "p2": "Wenn Sie mit irgendeinem Teil dieser Bedingungen nicht einverstanden sind, nutzen Sie unsere Website bitte nicht. Der Begriff 'Patal Kikian Villas' oder 'wir' bezieht sich auf den Eigentümer der Website. Der Begriff 'Sie' bezieht sich auf den Benutzer unserer Website.",
      "p3": "Der Inhalt der Seiten dieser Website dient nur zu Ihrer allgemeinen Information und Nutzung. Er kann ohne Vorankündigung geändert werden. Ihre Nutzung von Informationen oder Materialien auf dieser Website erfolgt auf eigenes Risiko, wofür wir nicht haften."
    },
    "booking": {
      "title": "Buchungsbedingungen",
      "p1_bold": "Ihr Vertrag mit Patal Kikian Villas:",
      "p1": "Diese Buchungsbedingungen sowie unsere Datenschutzrichtlinie bilden die Grundlage Ihres Vertrags mit Patal Kikian Villas. Mit der Buchung stimmt die erste genannte Person im Namen aller Personen zu, dass sie diese Bedingungen gelesen hat und berechtigt ist, sich daran zu binden.",
      "p2_bold": "Bezahlung Ihrer Buchung:",
      "p2": "Zum Zeitpunkt Ihrer Buchung müssen Sie gültige Kreditkartendaten angeben oder eine Anzahlung per Banküberweisung für eine Übernachtung leisten, um die Buchung zu bestätigen. No-Shows werden von den hinterlegten Kreditkartendaten abgebucht.",
      "p3_bold": "Genauigkeit:",
      "p3": "Wir bemühen uns sicherzustellen, dass alle Informationen und Preise auf unserer Website korrekt sind; gelegentlich treten jedoch Fehler auf, und wir behalten uns das Recht vor, Preise und andere Details in solchen Fällen zu korrigieren."
    },
    "cancellation": {
      "title": "Stornierungsrichtlinie",
      "p1_bold": "Standardraten:",
      "p1": "Bei Stornierungen innerhalb von 14 Tagen vor Ankunft wird eine Stornierungsgebühr für eine Nacht erhoben. Stornierungen innerhalb von 7 Tagen oder im Falle eines No-Shows führen zu einer 100%igen Gebühr des gesamten Buchungswertes.",
      "p2_bold": "Nicht erstattungsfähige Raten:",
      "p2": "Buchungen zu nicht erstattungsfähigen Preisen können nicht ohne 100%ige Gebühr storniert oder geändert werden."
    },
    "copyright": {
      "title": "Urheberrechtshinweis",
      "p1": "Diese Website und ihr Inhalt sind urheberrechtlich geschütztes Eigentum von Patal Kikian Villas. Alle Rechte vorbehalten. Jegliche Weitergabe oder Vervielfältigung von Teilen oder des gesamten Inhalts in jeglicher Form ist untersagt, außer das Herunterladen auf eine lokale Festplatte für den persönlichen und nicht kommerziellen Gebrauch."
    },
    "subtitle": "Legal",
    "title": "Allgemeine Geschäftsbedingungen"
  },
  "privacy": {
    "policy": {
      "title": "Datenschutzrichtlinie",
      "p1": "Wir verstehen, dass die Übermittlung persönlicher Informationen und Online-Einkäufe ein hohes Maß an Vertrauen Ihrerseits erfordern; wir nehmen dieses Vertrauen sehr ernst. Diese Datenschutzrichtlinie legt fest, wie Patal Kikian Villas alle Informationen schützt und verwendet, die Sie uns geben.",
      "p2": "Patal Kikian Villas verpflichtet sich sicherzustellen, dass Ihre Privatsphäre geschützt ist. Sollten wir Sie bitten, bestimmte Informationen anzugeben, können Sie sicher sein, dass sie nur gemäß dieser Datenschutzerklärung verwendet werden.",
      "p3": "Wir können diese Richtlinie gelegentlich ändern, indem wir diese Seite aktualisieren. Sie sollten diese Seite gelegentlich überprüfen, um sicherzustellen, dass Sie mit den Änderungen einverstanden sind."
    },
    "collect": {
      "title": "Was wir sammeln",
      "p1": "Wir können folgende Informationen sammeln:",
      "l1": "Name und Kontaktinformationen einschließlich E-Mail-Adresse",
      "l2": "Demografische Informationen wie Postleitzahl, Vorlieben und Interessen",
      "l3": "Andere Informationen, die für Kundenumfragen und/oder Angebote relevant sind",
      "l4": "Ihre Computer-IP-Adresse"
    },
    "usage": {
      "title": "Was wir mit den gesammelten Informationen tun",
      "p1": "Wir benötigen diese Informationen, um Ihre Bedürfnisse zu verstehen und Ihnen einen besseren Service zu bieten, insbesondere aus folgenden Gründen:",
      "l1": "Interne Aufzeichnungen.",
      "l2": "Wir können die Informationen verwenden, um unsere Produkte und Dienstleistungen zu verbessern.",
      "l3": "Wir können regelmäßig Werbe-E-Mails an die angegebene E-Mail-Adresse senden.",
      "l4": "Wir können die Informationen verwenden, um die Website an Ihre Interessen anzupassen.",
      "p2": "Sie können sich jederzeit von diesen Diensten abmelden, indem Sie uns per E-Mail an info@patalkikianbali.com kontaktieren."
    },
    "security": {
      "title": "Sicherheit & Finanzielle Informationen",
      "p1": "Wir verpflichten uns sicherzustellen, dass Ihre Informationen sicher sind. Um unbefugten Zugriff zu verhindern, haben wir geeignete Verfahren eingeführt, um die online gesammelten Informationen zu schützen.",
      "p2_bold": "Finanzielle Informationen:",
      "p2": "Derzeit speichern wir keine Kreditkartennummern auf unseren lokalen Servern. Zahlungen werden über sichere Drittanbieter abgewickelt."
    },
    "cookies": {
      "title": "Wie wir Cookies verwenden",
      "p1": "Ein Cookie ist eine kleine Datei, die um Erlaubnis bittet, auf der Festplatte Ihres Computers gespeichert zu werden. Sobald Sie zustimmen, hilft das Cookie bei der Analyse des Web-Traffics. Sie können Cookies über Ihre Browsereinstellungen akzeptieren oder ablehnen."
    },
    "subtitle": "Legal",
    "title": "Datenschutzrichtlinie"
  },
  "footer": {
    "explore": "Erkunden",
    "information": "Informationen",
    "contactTitle": "Kontakt",
    "contact": "Kontakt",
    "faq": "FAQ",
    "terms": "Allgemeine Geschäftsbedingungen",
    "privacy": "Datenschutzrichtlinie",
    "whatsappUs": "WhatsApp uns",
    "allRightsReserved": "Alle Rechte vorbehalten.",
    "newsJournal": "Nachrichten & Journal",
    "translate": "Übersetzen",
    "desc": "Erleben Sie das ruhige Leben in Sidemen. Genießen Sie spektakuläre Ausblicke auf den Mount Agung, Luxusvillen und herzliche Gastfreundschaft, perfekt für Reisende, die Entspannung auf Bali suchen.",
    "quickLinks": "Schnelllinks",
    "support": "Unterstützung"
  },
  "news": {
    "journal": "Journal",
    "latest": "Aktuelle Nachrichten & Geschichten",
    "subtitle": "Bleiben Sie informiert über die neuesten Nachrichten, Geschichten und Veranstaltungen rund um Patal Kikian und Sidemen.",
    "readNews": "Nachrichten Lesen",
    "allArticles": "Alle Artikel",
    "noArticles": "Keine Artikel in dieser Kategorie gefunden.",
    "page": "Seite",
    "of": "von"
  },
  "newsSearch": {
    "searchBreadcrumb": "Suche",
    "searchResults": "Suchergebnisse",
    "searchArticles": "Artikel Suchen",
    "resultsFound": "{{count}} Ergebnisse gefunden",
    "forQuery": " für \"{{query}}\"",
    "placeholder": "Artikel suchen...",
    "searchBtn": "Suchen",
    "noResults": "Keine Artikel für \"{{query}}\" gefunden.",
    "enterKeyword": "Geben Sie ein Stichwort ein, um zu suchen.",
    "backToNews": "Zurück zu Nachrichten"
  },
  "newsCategory": {
    "category": "Kategorie",
    "articlesInCat": "Artikel in dieser Kategorie",
    "noArticles": "Keine Artikel in dieser Kategorie gefunden.",
    "backToNews": "Zurück zu Nachrichten"
  },
  "newsDetail": {
    "tags": "Tags",
    "exclusiveStay": "Exklusiver Aufenthalt",
    "promoDesc": "Erleben Sie Premium-Luxus in Sidemen",
    "bookStay": "Buchen Sie Ihren Aufenthalt",
    "reserveStay": "Reservieren Sie Ihren Aufenthalt",
    "villaRecs": "Villa-Empfehlungen",
    "recAccommodations": "Empfohlene Unterkünfte",
    "readArticle": "Artikel Lesen",
    "search": "Suche",
    "searchPlaceholder": "Artikel suchen...",
    "go": "Los",
    "categories": "Kategorien",
    "popularPosts": "Beliebte Artikel",
    "bookNow": "Jetzt Buchen",
    "notFound": "Artikel Nicht Gefunden",
    "notFoundDesc": "Der gesuchte Artikel existiert nicht oder wurde verschoben.",
    "backToNews": "Zurück zu Nachrichten"
  }
}